import { SearchQueryVariables } from '@thg-commerce/gravity-patterns'

import { MOCK_PRODUCTS } from './ProductMock'

const InstantSearchCorrection = [
  {
    correction: 'protein',
    highlightedSearchCorrection: 'highlightedSearchCorrection',
    __typename: 'InstantSearchCorrection',
  },
]

export const MOCK_INSTANT_SEARCH = {
  products: MOCK_PRODUCTS(),
  corrections: InstantSearchCorrection,
  suggestedSearchQueries: [
    'protein',
    'protein bar',
    'protein cookie',
    'whey protein',
    'impact whey protein',
  ],
  __typename: 'InstantSearchResult',
}

export const instantSearchMockWithVariables = (
  variables: SearchQueryVariables,
) => {
  return {
    products: MOCK_PRODUCTS(variables.currency),
    corrections: InstantSearchCorrection,
    suggestedSearchQueries: [
      'protein',
      'protein bar',
      'protein cookie',
      'whey protein',
      'impact whey protein',
    ],
    __typename: 'InstantSearchResult',
  }
}
